import QRCode from 'qrcode'

const _makeImage = (dataUrl) => {
    const image = new Image()
    image.src = dataUrl

    return new Promise(resolve => {
        image.onload = () => {
            resolve(image)
        }
    })
}

const LABEL_WIDTH = 812
const LABEL_HEIGHT = 1220
export default async ({ trackingNumber, barcodeNumber }) => {
    const barcode_number = `#${barcodeNumber}`
    const data = await QRCode.toDataURL(trackingNumber, {
        errorCorrectionLevel: 'H',
        margin: 2,
        scale: 20,
        color: {
            dark: '#000000',
            light: '#FFFFFF'
        }
    })
    const qrImage = await _makeImage(data)

    const canvas = document.createElement('canvas')
    canvas.width = LABEL_WIDTH
    canvas.height = LABEL_HEIGHT
    const ctx = canvas.getContext('2d')

    ctx.fillStyle = 'white'
    ctx.fillRect(0, 0, LABEL_WIDTH, LABEL_HEIGHT)

    ctx.lineWidth = 4
    ctx.strokeStyle = '#000'
    ctx.strokeRect(10, 10, LABEL_WIDTH - 20, LABEL_HEIGHT - 20)

    const qrSize = LABEL_HEIGHT * 0.6
    const x = (LABEL_WIDTH - qrSize) / 2
    const y = (LABEL_HEIGHT - qrSize) / 2 - 40
    const bcY = (LABEL_HEIGHT - qrSize) / 2 - 100

    ctx.drawImage(qrImage, x, y, qrSize, qrSize)

    ctx.textAlign = 'left'
    ctx.fillStyle = 'black'

    ctx.font = 'bold 50px Arial'
    const barcodeY = bcY + qrSize + 100
    ctx.fillText(barcode_number, x + 40, barcodeY)

    return canvas.toDataURL()
}
